






























































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
/* api */
import MypageApi from '@/app/model/api/mypageApi'
/* module */
import Local from '@/app/module/local'
import { userType } from '@/app/model/store/domain/const'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    CommonHeader
  }
})
export default class Master extends Vue {
  private showMenuInfoModal: boolean = false
  private userType: string|null = ''
  private isAuth: boolean = false
  private externalLinkTitle: string = ''

  created () {
    if (parseInt(Local.getUserType()!) === userType.USER_TYPE_ADMIN) {
      this.isAuth = true
    }
    this.externalLinkTitle = CommonClass.getServiceFunctionData().external_link.external_link_name
  }
}
